import { __assign, __awaiter, __generator } from "tslib";
import { writable } from "svelte/store";
import { getUrlParams } from "../service/common.service";
import { config } from "../config";
export function loadWidget(urlParams) {
    return __awaiter(this, void 0, void 0, function () {
        var widgetId, ccPageUrl, pageUrl, scrclickid, srcsid, plcmt, endpoint;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    widgetId = urlParams.get("widget_id");
                    ccPageUrl = urlParams.get("cc_page_url") || 'conversion-cowboys.com';
                    pageUrl = urlParams.get("page_url");
                    scrclickid = urlParams.get("scrclickid");
                    srcsid = urlParams.get("srcsid");
                    plcmt = urlParams.get("plcmt");
                    endpoint = config.__TOP5_URL__ + "/v2/conversion-cowboy-widget/" + widgetId + "?seo_page_url=" + ccPageUrl + "&page_url=" + pageUrl + "&utm_source=" + trafficSource + "&widget_id=" + widgetId + "&scrclickid=" + scrclickid + "&srcsid=" + srcsid + "&plcmt=" + plcmt;
                    if (urlParams.get("preview_mode")) {
                        endpoint = endpoint + "&preview=true";
                    }
                    return [4 /*yield*/, fetch(endpoint)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
var trafficSource = 'cowboy-widget';
var initialState = {
    params: {},
    config: {
        widget_type: "",
        cta_text: "",
        cta_text_color: "",
        cta_color: "",
        background_color: "",
        title: "",
        title_color: "",
        sub_title: "",
        brand_choice: "",
        ad_text: "",
        display_partner_name: false,
        display_star_rating: true,
        display_score_as_text: false,
        partners: [],
        partner_row_background_color: "",
        logo_color: "",
    },
    isLoading: false,
    isError: false,
};
function createWidgetStore() {
    var _this = this;
    var _a = writable(initialState), subscribe = _a.subscribe, update = _a.update;
    return {
        subscribe: subscribe,
        params: getUrlParams(),
        loadWidget: function () { return __awaiter(_this, void 0, void 0, function () {
            var searchParams, res, seoPageUrl, widgetId, scrclickid, srcsid, plcmt, key, partners, params_1, widgetConfig_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update(function (state) { return (__assign(__assign({}, state), { isLoading: true })); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        searchParams = getUrlParams();
                        return [4 /*yield*/, loadWidget(searchParams)];
                    case 2: return [4 /*yield*/, (_a.sent()).json()];
                    case 3:
                        res = _a.sent();
                        seoPageUrl = searchParams.get("page_url");
                        widgetId = searchParams.get("widget_id");
                        scrclickid = searchParams.get("scrclickid");
                        srcsid = searchParams.get("srcsid");
                        plcmt = searchParams.get("plcmt");
                        // handle preview mode
                        if (searchParams.get("preview_mode")) {
                            for (key in res.widget) {
                                if (searchParams.get(key)) {
                                    res.widget[key] = searchParams.get(key);
                                }
                            }
                        }
                        partners = res.partners || [];
                        params_1 = "noclickin=true&clickin_id=" + res.clickin_id + "&token=" + res.token + "&referer_url=" + seoPageUrl + "&widget_id=" + widgetId + "&scrclickid=" + scrclickid + "&srcsid=" + srcsid + "&plcmt=" + plcmt;
                        partners.forEach(function (partner) {
                            if (partner.clickout_link.indexOf('?') > -1) {
                                partner.clickout_link = partner.clickout_link + "&" + params_1;
                            }
                            else {
                                partner.clickout_link = partner.clickout_link + "?" + params_1;
                            }
                        });
                        widgetConfig_1 = __assign(__assign({}, res.widget), { display_star_rating: widgetId !== 'jW5I94bLvC7gomj62SBh', partners: partners });
                        update(function (state) { return (__assign(__assign({}, state), { config: widgetConfig_1 })); });
                        return [3 /*break*/, 6];
                    case 4:
                        e_1 = _a.sent();
                        update(function (state) { return (__assign(__assign({}, state), { isError: true })); });
                        return [3 /*break*/, 6];
                    case 5:
                        update(function (state) { return (__assign(__assign({}, state), { isLoading: false })); });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); },
    };
}
export var widgetState = createWidgetStore();
